import { useState, useEffect } from 'react';
import archetypeService from '../helpers/archetypeService';
import useAuthStore from '../store/authStore';

export const useUserArchetype = () => {
    const { user } = useAuthStore();
    const [archetype, setArchetype] = useState(null);
    const [loading, setLoading] = useState(user?.userId ? true : false);
    const [error, setError] = useState(null);
    const [initialized, setInitialized] = useState(false);

    // Cargar arquetipo del usuario
    const loadUserArchetype = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await archetypeService.getUserArchetype();

            if (response.success && response.archetype) {
                setArchetype(response.archetype);
            } else {
                setArchetype(null);
            }
        } catch (err) {
            console.error('Error al cargar el arquetipo del usuario:', err.message);
            setError('Error al cargar el perfil del usuario');
        } finally {
            setLoading(false);
            setInitialized(true);
        }
    };

    // Cargar arquetipo al inicializar solo si hay usuario logueado
    useEffect(() => {
        if (user?.userId) {
            loadUserArchetype();
        } else {
            // Si no hay usuario, resetear el estado
            setArchetype(null);
            setLoading(false);
            setError(null);
            setInitialized(false);
        }
    }, [user]);

    // Refrescar arquetipo
    const refreshArchetype = () => {
        loadUserArchetype();
    };

    // Verificar si el usuario tiene arquetipo
    const hasArchetype = archetype !== null;

    // Obtener color del arquetipo basado en el nivel
    const getArchetypeColor = (nivel) => {
        switch (nivel) {
            case 'TRADICIONALES RESISTENTES':
                return '#FF6B6B';
            case 'EN TRANSICIÓN':
                return '#4ECDC4';
            case 'FUNCIONALES CON POTENCIAL':
                return '#45B7D1';
            case 'EARLY ADOPTERS Y ESCALADORES':
                return '#96CEB4';
            default:
                return '#6B7280';
        }
    };

    // Obtener recomendaciones basadas en el arquetipo
    const getRecommendations = (archetype) => {
        if (!archetype) return [];

        const recommendations = {
            'TRADICIONALES RESISTENTES': [
                'Comienza con herramientas básicas como WhatsApp Business',
                'Implementa un sistema de fidelización simple',
                'Crea contenido básico para redes sociales',
                'Aprende a usar un CRM básico'
            ],
            'EN TRANSICIÓN': [
                'Automatiza procesos de marketing',
                'Implementa email marketing',
                'Crea campañas de retargeting',
                'Analiza métricas básicas'
            ],
            'FUNCIONALES CON POTENCIAL': [
                'Optimiza campañas existentes',
                'Implementa análisis avanzado',
                'Automatiza más procesos',
                'Integra múltiples canales'
            ],
            'EARLY ADOPTERS Y ESCALADORES': [
                'Implementa IA en marketing',
                'Usa integraciones avanzadas',
                'Optimiza para conversión',
                'Escala a múltiples mercados'
            ]
        };

        return recommendations[archetype.nivel] || [];
    };

    return {
        // Estado
        archetype,
        loading,
        error,
        hasArchetype,
        initialized,

        // Acciones
        refreshArchetype,
        loadUserArchetype,

        // Utilidades
        getArchetypeColor,
        getRecommendations
    };
}; 